/* eslint-disable react/jsx-one-expression-per-line */
import React, { useState, useEffect } from 'react';
import { useHistory, useLocation, Redirect } from 'react-router-dom';
import * as Sentry from '@sentry/react';
import PATH from 'routes/path';
import { useSnackbar } from 'notistack';

import { getCaseById, sendEmail } from 'services/api/cases';
import { createEventTracking } from 'services/api/tracking';
import HelpIcon from '@material-ui/icons/Help';
import GetAppIcon from '@material-ui/icons/GetApp';
import { Tooltip, IconButton } from '@material-ui/core';
import {
  getCustomers,
  updateCustomer,
} from 'services/api/customers';
import { Input } from 'components/Input';
import { Button } from 'components/Button';
import { Text, Title } from 'components/Text';
import { ALERT_TYPE } from 'components/Alert';
import Loading from 'components/Loading';
import SnackMessage, { OPTIONS } from 'components/SnackMessage';

import HelpModal from './HelpModal';
import {
  Wrapper, Header,
  ButtonWrapper, InputWrapper,
} from './styles';

// Página de Download
const Download = () => {
  const [fgts, setFgts] = useState({});
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [loadingData, setLoadingData] = useState(true);
  const [openHelp, setOpenHelp] = useState(false);

  const history = useHistory();

  const location = useLocation();

  const { idCase } = location.state;

  const { enqueueSnackbar } = useSnackbar();

  const handleChange = (e) => setEmail(e.target.value);

  const showHelp = () => {
    window.Intercom('trackEvent', 'LOIT FGTS download ajuda');
    setOpenHelp(true);
  };

  const closeHelp = () => setOpenHelp(false);

  const downloadPetition = () => {
    createEventTracking('170 - download efetuado (petição)');
    window.open(fgts.petition_url);

    setTimeout(() => {
      enqueueSnackbar('Download de Petição concluído.', {
        ...OPTIONS,
        content: (key, message) => (
          <SnackMessage
            id={key}
            message={message}
            variant={ALERT_TYPE.SUCCESS}
          />
        ),
      });
    }, 1000);
  };

  const donwloadCalculation = () => {
    createEventTracking('180 - download efetuado (cálculo)');
    window.open(fgts.pdf_url);

    setTimeout(() => {
      enqueueSnackbar('Download de Cálculo concluído.', {
        ...OPTIONS,
        content: (key, message) => (
          <SnackMessage
            id={key}
            message={message}
            variant={ALERT_TYPE.SUCCESS}
          />
        ),
      });
    }, 1000);
  };

  const goToHome = () => history.push(PATH.HOME);

  // Carrega os dados do caso
  const loadCaseData = async () => {
    setLoadingData(true);

    try {
      const { data } = await getCaseById(idCase);
      setFgts(data.case_fgts[0]);
    } catch (error) {
      // console.error(error);
      enqueueSnackbar('Desculpe, ocorreu um erro ao carregar os dados do caso.', {
        ...OPTIONS,
        content: (key, message) => (
          <SnackMessage
            id={key}
            message={message}
            variant={ALERT_TYPE.ERROR}
          />
        ),
      });
      Sentry.captureException(new Error('failed to fetch case'));
    } finally {
      setLoadingData(false);
    }
  };

  const handleUpdateStep = async () => {
    const customer = await getCustomers();

    setEmail(customer.data[0].email);

    const payload = {
      ...customer.data[0],
      meta_data: {
        ...customer.data[0].meta_data,
        step: 5,
        idCase,
      },
    };
    await updateCustomer(customer.data[0].id, payload);
  };

  useEffect(() => {
    document.title = 'Downloads - Revisão FGTS - LOIT';

    handleUpdateStep();
    window.Intercom('trackEvent', 'LOIT FGTS download');
    createEventTracking('160 - download');
    loadCaseData();
  }, []);

  // Envio dos arquivos por E-mail
  const handleSubmit = async (e) => {
    e.preventDefault();

    setLoading(true);

    const payload = { email };

    try {
      await sendEmail(idCase, payload);
      setEmail('');
      enqueueSnackbar('E-mail enviado com sucesso!', {
        ...OPTIONS,
        content: (key, message) => (
          <SnackMessage
            id={key}
            message={message}
            variant={ALERT_TYPE.SUCCESS}
          />
        ),
      });
    } catch (error) {
      // console.error(error);
      enqueueSnackbar('Desculpe, ocorreu um erro ao enviar o E-mail!', {
        ...OPTIONS,
        content: (key, message) => (
          <SnackMessage
            id={key}
            message={message}
            variant={ALERT_TYPE.ERROR}
          />
        ),
      });
      Sentry.captureException(new Error('failed to send email'));
    } finally {
      setLoading(false);
    }
  };

  if (!idCase) return <Redirect to={PATH.HOME} />;

  if (loadingData) return <Loading bg="none" height="100%" />;

  return (
    <Wrapper>
      <Header>
        <Title secondary>Download do kit</Title>
        {/* ICONE DE AJUDA */}
        <Tooltip title="Sobre o Download" arrow>
          <IconButton
            size="small"
            color="secondary"
            onClick={showHelp}
            disabled={openHelp}
          >
            Ajuda
            <HelpIcon />
          </IconButton>
        </Tooltip>
      </Header>
      {/* MODAL DE AJUDA */}
      {
        openHelp && (
          <HelpModal
            open={openHelp}
            onClose={closeHelp}
          />
        )
      }
      <Text>
        Seu kit já foi encaminhado para o seu e-mail.
      </Text>
      <Text>
        Caso você queira enviar novamente, você sempre poderá fazer aqui:
      </Text>
      {/* Formulário de E-mail */}
      <form onSubmit={handleSubmit}>
        <InputWrapper>
          <Input
            required
            type="email"
            value={email}
            onChange={handleChange}
            placeholder="exemplo@gmail.com"
          />
          <Button
            loading={loading}
            disabled={loading}
            type="submit"
          >
            Enviar
          </Button>
        </InputWrapper>
      </form>
      <Text>
        Você pode também fazer o download dos itens do seu kit,
        Petição e Cálculo aqui:
      </Text>
      <ButtonWrapper>
        <Button
          disabled={!fgts.petition_url}
          endIcon={<GetAppIcon />}
          onClick={downloadPetition}
        >
          Petição
        </Button>
        <Button
          disabled={!fgts.pdf_url}
          endIcon={<GetAppIcon />}
          onClick={donwloadCalculation}
        >
          Cálculo
        </Button>
      </ButtonWrapper>
      <Title secondary style={{ fontSize: '16px' }}>
        Dúvidas sobre como entrar com o pedido?
      </Title>
      <Title secondary style={{ fontSize: '16px' }}>
        Acesse as orientações nos materiais de apoio a seguir:
      </Title>
      <Text>
        <a
          target="_blank"
          rel="noreferrer"
          href="https://ajuda.tikal.tech/pt-BR/articles/4852201-o-que-faco-agora-que-tenho-o-kit"
        >
          O que faço agora que tenho o kit?
        </a>
      </Text>
      <Text>
        <a
          target="_blank"
          rel="noreferrer"
          href="https://ajuda.tikal.tech/pt-BR/articles/4848739-entrando-com-o-processo-no-juizado-especial-federal"
        >
          Orientações para entrar com a ação de revisão do FGTS
        </a>
      </Text>
      <Button
        onClick={history.goBack}
        variant="outlined"
      >
        Voltar à tela de documentos
      </Button>
      <Button
        variant="outlined"
        className="unset"
        onClick={goToHome}
      >
        Voltar
      </Button>
    </Wrapper>
  );
};

export default Download;
